import { apiResultSuccess, markWorkoutAsDone, restartWorkout } from "../apihelper";
import ModuleController from "./ModuleController";
import Workout from "../models/workout";

export default class WorkoutController extends ModuleController {
    constructor(workout={}) {
        super();
        this.workout = workout;
        this.animate = false;
    }

    getWorkout() {
        return this.workout;
    }

    setWorkout(newWorkout) {
        this.workout = new Workout(newWorkout);
        this.workout.animate = true;
        this.subject.runReload();
    }

    // Creates new workout from editData
    // Runs reload on subject
    editWorkout(editData={}) {
        this.workout = new Workout(editData);
        this.subject.runReload();
    }

    // API helper
    // Checks for success
    // Upon success calls setWorkout
    handleAPIResult(result) {
        if ( apiResultSuccess(result) ) {
            if ( result.workout ) {
                this.setWorkout(result.workout);
            }
        }
    }

    // Marks workout as done calling API markWorkoutAsDone fn
    // Calls handleAPIResult
    markDone() {
        markWorkoutAsDone(
            (results) => {
                this.handleAPIResult(results);
            }, this.workout.getId()
        )
    }

    // Restarts workout calling API restartWorkout fn
    // Calls handleAPIResult
    restart() {
        restartWorkout(
            (results) => {
                this.handleAPIResult(results);
            }, this.workout.getId()
        )
    }
}